const OUTLOOK_MESSAGE_TYPE = 'application/vnd.ms-outlook';

export function isOutlookMessage(fileName: string): boolean {
  const fileParts = fileName.split('.');
  const extension = fileParts.length > 1 ? fileParts[fileParts.length - 1] : '';
  return extension === 'msg';
}

/**
 * The file type to store with an uploaded file. Browsers often report an
 * empty type for Outlook `.msg` files, while `FileService.upload` PUTs them
 * with the Outlook content type; the stored type must match that upload.
 */
export function uploadFileType(file: File): string {
  return isOutlookMessage(file.name) ? OUTLOOK_MESSAGE_TYPE : file.type;
}
